enum FormStatuses {
  Current = 'Current',
  NewVersionAvailable = 'NewVersionAvailable',
  Removed = 'Removed',
  FormInReview = 'FormInReview',
}

export default FormStatuses;
